<app-layout preset="data">
  <app-layout-title>{{ 'SIDENAV.ROOT.documents' | translate }}</app-layout-title>

  <app-layout-content>
    <app-search #nameFilter field="name" [localeSearch]="true">
      {{ 'COMMON.search_by_name' | translate }}
    </app-search>
    <app-hint>
      <span>{{ 'ADMIN.assign_projects_hint' | translate }} <mat-icon color="primary">edit</mat-icon>
    </span>
  </app-hint>

  <app-table [columns]="columns"
    [dataSource]="dataSource"
    [filter]="nameFilter"
    [reloader]="reloader"
    loadingType="all">

    <ng-container *app-table-header="'document'">{{ 'DOCUMENT_EXTENSIONS.TABLE.document' | translate }}</ng-container>
    <ng-container *app-table-header="'courier'">{{ 'DOCUMENT_EXTENSIONS.TABLE.courier' | translate }}</ng-container>
    <ng-container *app-table-header="'projects'">{{ 'DOCUMENT_EXTENSIONS.TABLE.projects' | translate }}</ng-container>

    <app-heading *app-table-column="let document; name: 'document'"
      [subtitle]="document.type | label:'documents' | async"
      [title]="document.name"
      hAlign="center">
    </app-heading>

    <ng-container *app-table-column="let document; name: 'courier'">

      @if (document.courier) {
        <app-colorized-text textColor="black">{{document.courier.name}}</app-colorized-text>
      } @else {
        <app-colorized-text textColor="gray">{{ 'HISTORY.RECONCILIATION.missing' | translate }}</app-colorized-text>
      }

      <app-colorized-text [textColor]=""></app-colorized-text>
    </ng-container>

    <ng-container *app-table-column="let document; name: 'projects'">
      <div class="assigned-projects">
        <app-scrollable-list [count]="document.projects.length">
          <div class="project-list">
            @if (!document.projects.length) {
              <app-colorized-text textColor="gray" align="center">
                {{ 'ADMIN.no_projects' | translate }}
              </app-colorized-text>
            }
            @for (project of document.projects; track project) {
              <app-project-view
                [iso]="project.isoCode"
                [name]="project.name"
                class="project">
              </app-project-view>
            }
          </div>
        </app-scrollable-list>
        <button (click)="openDocumentEditor(document)" mat-icon-button>
          <mat-icon color="primary">edit</mat-icon>
        </button>
      </div>
    </ng-container>
  </app-table>
</app-layout-content>
</app-layout>
